import React, { useState, useEffect } from 'react';

const VisionMission = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const styles = {
        section: {
            padding: isMobile ? '0px' : '40px',
            margin: '0 auto',
        },
        container: {
            maxWidth: isMobile ? '100%' : '1200px',
            margin: '0 auto',
            padding: '0 15px',
        },
        heading: {
            textAlign: 'center',
            paddingBottom: '20px',
            fontSize: isMobile ? '24px' : '32px',
            color: '#343a40',
        },
        row: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            gap: '20px',
        },
        col: {
            flex: '1',
            minWidth: isMobile ? '100%' : '300px',
            boxSizing: 'border-box',
            marginBottom: isMobile ? '20px' : '0',
        },
        contentBox: {
            backgroundColor: '#F16621',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
            color: 'white',
        },
        subheading: {
            color: 'white',
            fontSize: '20px',
            marginBottom: '10px',
        },
        text: {
            color: 'white',
            lineHeight: '1.6',
        },
        titleAccent: {
            color: '#F16621',
        },
    };

    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <h3 style={{ ...styles.heading, ...styles.titleAccent }}>
                    About Our Vision & Mission
                </h3>
                <div style={styles.row}>
                    <div style={styles.col}>
                        <div style={styles.contentBox}>
                            <h4 style={styles.subheading}>Vision</h4>
                            <p style={styles.text}>
                                At Prince Cabs, our vision is to revolutionize urban mobility by offering safe, seamless, and eco-friendly transport solutions. We aspire to be the preferred travel partner by embracing innovation, customer satisfaction, and operational excellence.
                            </p>
                        </div>
                    </div>
                    <div style={styles.col}>
                        <div style={styles.contentBox}>
                            <h4 style={styles.subheading}>Mission</h4>
                            <p style={styles.text}>
                                Our mission at Prince Cabs is to provide reliable, timely, and comfortable rides with professional drivers and well-maintained vehicles. We are committed to delivering high-quality services tailored to the needs of modern commuters, while upholding integrity, safety, and customer delight in every ride.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VisionMission;
